module.exports = __webpack_public_path__ + "static/media/unsuccessfulTaxDataLogo.b354e42d.svg";